import { assert } from './internal';

type ASSERT_OPTIONS = Parameters<typeof assert>[1];

type Guard<T> = (input: unknown, ...rest: unknown[]) => asserts input is T;

// eslint-disable-next-line ts/no-unsafe-function-type
function ensure<G extends Guard<T>, T>(guard: Function, value: unknown): InferGuardValue<G>;
// eslint-disable-next-line ts/no-unsafe-function-type
function ensure<G extends Guard<T>, T>(guard: Function, value: unknown, options: ASSERT_OPTIONS): InferGuardValue<G>;
function ensure<G extends Guard<T>, T>(guard: G, value: unknown, options?: ASSERT_OPTIONS): InferGuardValue<G> {
  assert(guard(value), ...(options ? [options] : []));
  return value as InferGuardValue<G>;
}

export default ensure;
